// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__HswBA","icons":"styles_icons__qRaLB","links1":"styles_links1__oBFyk","links2":"styles_links2__PtHTW","transparente":"styles_transparente__McxO1"};